import React, { useEffect, useState } from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Button, Modal, Row, Col } from "reactstrap"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import SimpleBar from "simplebar-react"
import * as url from "../../../helpers/url_helper"
import moment from "moment"
import { Chrono } from "react-chrono";
import { BarLoader, BounceLoader } from "react-spinners";


//i18n
import { withTranslation } from "react-i18next"

const NotificationEnlevementDropdown = props => {

  useEffect(() => { setInterval(() => { getDemandes() }, 10000); }, [])
  
  const [menu, setMenu] = useState(false)
  const [enlevements, setEnlevements] = useState([])
  const [count, setCount] = useState(0)
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [detail, setDetail] = useState(null);
  const [modal_opera, setmodal_opera] = useState(false)
  const [loadingConfirm, setLoadingConfirm] = useState(false);

  function tog_get_opera() { setmodal_opera(!modal_opera); removeBodyCss() }
  function removeBodyCss() { document.body.classList.add("no_padding") }

  const getDemandes=()=> {
    fetch(url.API_LIVRAISON_BACKEND+"/enlevements?stat=0&size=50", {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      if (responseJson.status==200) { 
        setEnlevements(responseJson.data)
    } else {  }
    }) .catch((error) => {  });
  };

  const getOperation=(item)=> {
    // let timeLine=[];
    // timeLine= [
    //   ...timeLine,
    //   ...item.operation.actions.map(ite=>(
    //     {
    //       title: ite.nom,
    //       cardTitle: ite.nom,
    //       cardSubtitle: "Ue Digital",
    //       cardDetailedText: moment(ite.create).format("DD-MM-YYYY HH:mm:SS")
    //     }
    //   ))
    // ]
    return (
        <Row>
          <Col xl="7">
            <div className="table-rep-plugin">
              <div className="table-responsive mb-0" data-pattern="priority-columns">
              <Table id="tech-companies-1" className="table table-striped table-bordered">
                <Tbody>
                  <Tr><Td>Client</Td><Td><strong>{item.clt.nom} {item.clt.phone}, {item.phone}</strong></Td></Tr>
                  <Tr><Td>Adresse de récupération</Td><Td><strong>{item.zone.commune.nom}, {item.zone.nom}, {item.address}</strong></Td></Tr>
                  <Tr><Td>Frais </Td><Td><strong>{item.tarif} FCFA</strong></Td></Tr>
                  <Tr><Td>Agence Bénéficiaire</Td><Td><strong>{item.agdest.nom}</strong></Td></Tr>
                  <Tr><Td>Bénéficiaire</Td><Td><strong>{item.benef} ({item.destphone})</strong></Td></Tr>
                  <Tr><Td>Date demande</Td><Td><strong>{moment(item.create).format("DD-MM-YY HH:mm:ss")}</strong></Td></Tr>
                </Tbody>
              </Table>
              </div>
            </div>
          </Col>
          {/* <Col xl="5" style={{ height: "500px", overflow: "auto" }}>
            <Chrono disableToolbar={true} mode="VERTICAL_ALTERNATING" cardHeight={80} fontSizes={{ title: "9pt", cardTitle: "9pt", cardSubtitle: "7pt", cardDetailedText: "5pt"}} cardWidth={180} items={timeLine} />
          </Col> */}
        </Row>);};

  return (
    <React.Fragment>
      <Modal size="xl" isOpen={modal_opera} toggle={() => { tog_get_opera() }}>
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myLargeModalLabel">Consultation détails demande</h5>
         
          {detail && detail.stat==0 ? 
          (<Col xl="3">
            <Button className="btn btn-lg btn-primary" tag="button" onClick={()=>{confirmDemande()}}>
             CONFIRMER LA DEMANDE 
            </Button>
            <span>{loadingConfirm ? (<BounceLoader size={30} color="green"/>): null}</span>
          </Col>): (null)}
        </div>
          {detail && getOperation(detail)}
      </Modal>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block ms-1"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon waves-effect"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="ion ion-ios-cube"></i>
          <span className="badge text-bg-danger rounded-pill">{enlevements.length}</span>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h5 className="m-0"> Demandes d'enlèvement en attentes ({enlevements.length}) </h5>
              </Col>
            </Row>
          </div>

          <SimpleBar style={{ height: "230px" }}>
          {enlevements && enlevements.length >0 ?
            (enlevements.map((item, key)=>(<Link to="#" className="text-reset notification-item">
              <div className="d-flex" onClick={()=>{setDetail(item); setTimeout(() => { tog_get_opera() }, 100);}}>
                <div className="flex-shrink-0 me-3">
                  <div className="avatar-xs me-3">
                    <span className="avatar-title border-success rounded-circle ">
                      <i className="mdi mdi-cart-outline"></i>
                    </span>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <h6 className="mt-0 mb-1">Demande de {item.clt ? item.clt.nom: null}</h6>
                  <div className="text-muted">
                    <p className="mb-1">Récupération {item.zone ? item.zone.nom: null}  {item.address}</p>
                    <p className="mb-1">Destination {item.agdest ? item.agdest.nom: null}</p>
                    <p className="mb-1">Date de la demande {moment(item.create).format("DD-MM-YY HH:mm:ss")}</p>
                  </div>
                </div>
              </div>
            </Link>)

          )): null}
          </SimpleBar>
          <div className="p-2 border-top d-grid">
            <Link
              className="btn btn-sm btn-link font-size-14 btn-block text-center"
              to="#"
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>
              {" "}
              {props.t("View all")}{" "}
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

export default withTranslation()(NotificationEnlevementDropdown)

NotificationEnlevementDropdown.propTypes = {
  t: PropTypes.any
}